<template>
	<div class="pc-p">
		<!-- <div class="erweima">
			<div></div>
		</div> -->
        <div class="content">
            <img class="logo" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021110198ed932a3bf06220130296.png" alt="huafalogo">
            <!-- upodata 活动日期 -->
            <img class="theme" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211213b96eec40e82e564e315368.png" alt="">
            <img class="time" src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211105006443e19553bc60776848.png" alt="">
            <div class="qrcode">
                <img src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211026202ab1235151173a290739.png" alt="">
                <!-- <img src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021102670feaf2728e12725436910.png" alt=""> -->
                <img src="https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211112ef0d502a3f9bf376532512.png" alt="">
            </div>
        </div>
		<div class="pcBox">
			<div class="box">
                <iframe id="myframe" allowfullscreen="true" src="https://h5case4.xiaoxxx.cn/202110/HUAFA/index.html" style=""></iframe>
                <!-- <iframe id="myframe" allowfullscreen="true" src="http://172.18.11.32:8080/#/" style=""></iframe> -->
			</div>	
		</div>
		<!-- <div class="title"> -->
			<!-- <div class="title_t">请扫描左侧二维码获取pc端登录用户名及密码， 登录成功后点击我的视频开始上传 </div> -->
		<!-- </div> -->
		<!-- <div class="jiantou"> -->
		<!-- </div> -->
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	methods: {
    }
};
</script>
<style>

</style>
<style scoped>
.content {
    width: 600px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 12%;
}
.logo {
    width: 160px;
}
.theme {
    width: 500px;
}
.time {
    width: 460px;
    margin-top: -50px;
}
.pc-p {
	position: relative;
	width: 100vw;
	min-width: 1440px;
	height: 100vh;
	min-height: 900px;
	overflow-x: auto;
	background: url("https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211105c708c8b009421adf614216.jpg");
	background-size: cover;
	background-repeat: no-repeat;
	background-position: bottom;
}  
.erweima{
    background: url('../assets/images/erweima.png');
    background-size: contain;
    width: 100px;
    height: 85px;
    position: absolute;
    bottom: 10%;
    left: 10%;
    transform: translate(-50%,-50%) scale(.9);
    overflow: hidden;  
}
.box{
        width: 102px;
        height: 102px;
}
.pcBox {
    background: url('../assets/images/roll.png');
    background-size: 375px 680px;
    width: 375px;
    position: absolute;
    top: 50%;
    left: 78%;
    transform: translate(-50%,-50%);
    overflow: hidden;
    /* // border: .2rem solid #fff5eb; */
    /* // border-radius: .3rem; */
    }
    .box{
    width: 375px; 
    height: 680px;
    }
    .title{
    position: absolute;
    bottom: 8%;
    left: 78%;
    transform: translateX(-50%);
    }
    .title_t{
        width: 375px;
        color: #FFFFFF;
        font-size: 15px;
        text-align: left;
    }
    .jiantou{
    background: url('../assets/images/jiantou.png') center no-repeat;
    background-size: contain; 
    position: absolute;
    bottom: 13.8%;
    right: 12%;
    width: 25px;
    height: 50px;
    }
	
    #myframe {
        width: 96%;
        height: 98%;
        border-radius: 15px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .qrcode {
        /* position: absolute;
        left: 5%;
        bottom: 8%; */
        display: flex;
        margin-top: 30px;
    }
    .qrcode img {
        height: 150px;
        margin: 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pc.vue